module.exports = __webpack_public_path__ + "static/media/brews.376943da.png";